import config from "@/config";
import { useCurrentUser } from "@/hooks/useCurrentUser";

/**
 * Hook that returns the Stripe connection status and connect URL.
 */
export function useStripeStatus() {
  const { user, isLoading } = useCurrentUser();

  const stripeActive = user?.stripeActive ?? false;

  // Build the Stripe onboarding URL using the user's hash
  // The API URL already ends with /api, so we just append the path
  const stripeConnectUrl = user?.hash
    ? `${config.apiUrl}/onboarding/start/${user.hash}`
    : null;

  return {
    stripeActive,
    stripeConnectUrl,
    isLoading,
    user,
  };
}
